import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const MultiStepFormLayout_Box_1 = styled.div`
  display: none;
  width: 33.33%;
  max-width: 572px;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: block;
  }
`;

export const MultiStepFormLayout_Box_2 = styled.div`
  height: 100%;
  flex: 1 1 auto;
  margin: 0 auto;

  &[data-has-sidebar] {
    padding-inline: ${gutterWidth / 2}px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      padding-inline: ${gutterWidth}px;
    }

    @media all and (min-width: ${cssBreakpoints.lgUp}) {
      padding-inline: ${gutterWidth * 2}px;
    }
  }
`;
